import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {TableColumnSizeType} from "../../../commons/types/table-column-size.type";

export class FulfillmentStepsTableComponent implements IController {

  displayAsItems: boolean;
  columns: any;
  dynamicColumns?: any;
  packageDynamicColumns?: any;
  infiniteScroll: any;
  selectedIds: string[];
  excludeMode: boolean;
  selectedFulfillmentId: string;
  onFulfillmentSelect: Function;
  onSelect: Function;
  onDispatch: Function;
  onDispatchExternal: Function;
  onSplit: Function;
  onAutoAssign: Function;
  onAssignAgent: Function;
  onCancelService: Function;
  onCancelAttempt: Function;
  onReset: Function;
  onAssignRoute: Function;
  onAssignResourceAllocation: Function;
  onCompleteManually: Function;
  onAddNote: Function;
  onCreateRoute: Function;
  onCancelStep: Function;
  onCreateVoucher: Function;
  onSortTypeChange: Function;
  onFilterByType: Function;

  private selectedKeys = undefined;
  public readonly skeletonRows: undefined[] = Array.from({length: 10});
  public asceDescIconsMap: any;
  public isScrollable: boolean;
  public tableColumnSizeType: typeof TableColumnSizeType = TableColumnSizeType;
  public dynamicColumnWidthClass: string;
  public defaultColumnsSize: {} = {
    fulfillment: {
      size: TableColumnSizeType.small
    },
    leg: {
      size: TableColumnSizeType.small
    },
    actions: {
      size: TableColumnSizeType.xsmall
    }
  }


  constructor(private commonsConstants, private commonsService: CommonsService) {
  }

  $onInit() {
    this.asceDescIconsMap = this.commonsConstants.sortIconsMap;
    this.dynamicColumnWidthClass = this.tableColumnSizeType.small;
    this.setSelectedKeys();
  }

  $doCheck() {
    const elementRefs = document.getElementsByClassName("bringoz-table")
    this.isScrollable = !elementRefs.length ? true : elementRefs[0].clientWidth < this.commonsService.calculateTableColumnsTotalWidth({...this.defaultColumnsSize, ...this.columns}, this.dynamicColumns, this.commonsConstants.tableColumnSizes[this.dynamicColumnWidthClass]);
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.setSelectedKeys();
    }
  };

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

  setSelectedKeys() {
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (id) => {
      this.selectedKeys[id] = true;
    });
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepsTable', {
    bindings: {
      columns: '<',
      dynamicColumns: '<?',
      packageDynamicColumns: '<?',
      displayAsItems: '<?',
      infiniteScroll: '<',
      selectedIds: '<',
      excludeMode: '<?',
      sortType: '<?',
      selectedFulfillmentId: '<',
      onSortTypeChange: '&',
      onFulfillmentSelect: '&',
      onSelect: '&',
      onToggleSelectAll: '&',
      onDispatch: '&',
      onDispatchExternal: '&',
      onSplit: '&',
      onAutoAssign: '&',
      onAssignAgent: '&',
      onCancelService: '&',
      onCancelAttempt: '&',
      onReset: '&',
      onAssignRoute: '&',
      onAssignResourceAllocation: '&',
      onCompleteManually: '&',
      onAddNote: '&',
      onCreateRoute: '&',
      onCancelStep: '&',
      onFilterByType: '&',
      onCreateVoucher: '&'
    },
    template: require('./fulfillment-steps-table.html').default,
    controller: FulfillmentStepsTableComponent
  });
